import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { useDebouncedValue } from 'ziphy-web-shared/basic/hooks'
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields'

const SymptomsSearchBar = ({ onChange }) => {
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState('')
  const debouncedSearchValue = useDebouncedValue(searchValue)

  useEffect(() => onChange(debouncedSearchValue), [debouncedSearchValue])

  // TODO check Input when symptoms will be enabled
  return (
    <Input
      className="symptoms-search mb-30"
      field={{ value: searchValue, onChange: setSearchValue }}
      placeholder={t('symptoms.ph.search')}
      helpText={t('symptoms.ph.search_help')}
      mode={['secondary', 'md']}
      leftElement={'search'}
      clear={true}
      clearedValue={''}
    />
  )
}

export default SymptomsSearchBar
